import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const placeServicesService = {
  // Retorna todos os serviços de um local
  // GET /api/places/{placeId}/services
  getByPlaceId: async (placeId) => {
    const response = await api.get(`/places/${placeId}/services`);
    return extractData(response.data);
  },

  // Retorna os serviços disponíveis para adicionar ao local (não estão no local ainda)
  // GET /api/places/{placeId}/services/available
  getAvailableForPlace: async (placeId) => {
    const response = await api.get(`/places/${placeId}/services/available`);
    return extractData(response.data);
  },

  // Buscar por ID específico de um serviço em um local
  // GET /api/places/{placeId}/services/{serviceId}
  getById: async (placeId, serviceId) => {
    const response = await api.get(`/places/${placeId}/services/${serviceId}`);
    return extractData(response.data);
  },

  // Adicionar serviço ao local
  // POST /api/places/{placeId}/services
  // Body: { serviceId }
  create: async (placeId, data) => {
    const response = await api.post(`/places/${placeId}/services`, data);
    return extractData(response.data);
  },

  // Atualizar PlaceService
  // PUT /api/places/{placeId}/services/{serviceId}
  update: async (placeId, serviceId, data) => {
    const response = await api.put(`/places/${placeId}/services/${serviceId}`, data);
    return extractData(response.data);
  },

  // Remover serviço do local
  // DELETE /api/places/{placeId}/services/{serviceId}
  // ✅ Validação happens in API (isInUseAsync)
  // Se houver erro (400), a exceção vai ser lançada pelo axios
  // Quem chama trata o erro
  delete: async (placeId, serviceId) => {
    await api.delete(`/places/${placeId}/services/${serviceId}`);
    // Se chegou aqui, foi sucesso (204 No Content)
  },
};

export default placeServicesService;
